@if (isDesktop$ | async) {
  <div class="my-0 px-0 now-layout-card" id="filter" role="presentation">
    <ng-container *ngTemplateOutlet="filter"></ng-container>
  </div>
} @else {
  <now-wbsuche-lib-facetten-slide-in
    [loading]="(loading$ | async)!"
    (resetAllFilters)="setzeFilterZurueck()"
  >
    <ng-container *ngTemplateOutlet="filter"></ng-container>
  </now-wbsuche-lib-facetten-slide-in>
}

<ng-template #filter>
  @if ({ erweiterteSucheActive: erweiterteSucheActive$ | async }; as context) {
    <div [ngClass]="(isDesktop$ | async) ? 'now-filter-sets-container' : 'now-accordion-filter'">
      <now-wbsuche-lib-ort-facette [postleitzahl]="postleitzahl"></now-wbsuche-lib-ort-facette>
      <now-wbsuche-lib-umkreis-facette></now-wbsuche-lib-umkreis-facette>
      <now-wbsuche-lib-weiterbildungsart-facette></now-wbsuche-lib-weiterbildungsart-facette>
      <now-wbsuche-lib-foerderart-facette></now-wbsuche-lib-foerderart-facette>
      <now-wbsuche-lib-beginntermin-facette></now-wbsuche-lib-beginntermin-facette>
      <now-wbsuche-lib-unterrichtszeit-facette></now-wbsuche-lib-unterrichtszeit-facette>
      <now-wbsuche-lib-dauer-facette></now-wbsuche-lib-dauer-facette>
      @if (!context.erweiterteSucheActive) {
        <now-wbsuche-lib-unterrichtsform-facette></now-wbsuche-lib-unterrichtsform-facette>
      }
      @if (context.erweiterteSucheActive) {
        <now-wbsuche-lib-vorort-facette></now-wbsuche-lib-vorort-facette>
        <now-wbsuche-lib-fernunterricht-facette></now-wbsuche-lib-fernunterricht-facette>
        <now-wbsuche-lib-digitale-lernform-facette></now-wbsuche-lib-digitale-lernform-facette>
        <now-wbsuche-lib-kombinierte-lernform-facette></now-wbsuche-lib-kombinierte-lernform-facette>
        <now-wbsuche-lib-kosten-facette></now-wbsuche-lib-kosten-facette>
        <now-wbsuche-lib-anbieter-facette></now-wbsuche-lib-anbieter-facette>
        <now-wbsuche-lib-barrierefreiheit-facette></now-wbsuche-lib-barrierefreiheit-facette>
      }
      @if (isDesktop$ | async) {
        <now-wbsuche-lib-filter-zuruecksetzen></now-wbsuche-lib-filter-zuruecksetzen>
      }
    </div>
  }

  <div class="d-lg-flex mt-2">
    <now-wbsuche-lib-erweiterte-suche-toggle></now-wbsuche-lib-erweiterte-suche-toggle>
  </div>
</ng-template>

<ng-template
  #infoPopup
  let-modalId="modalId"
  let-title="title"
  let-label="label"
  let-content="content"
>
  <now-wbsuche-lib-modal-popup
    [modalId]="modalId"
    [modalTitle]="title"
    primaryButtonText="Schließen"
    secondaryButtonText=""
    [ariaLabel]="'Begriffserklärung ' + label"
  >
    <p [innerHTML]="content"></p>
  </now-wbsuche-lib-modal-popup>
</ng-template>

@for (modalData of modalPopups; track modalData.modalId) {
  <ng-container *ngTemplateOutlet="infoPopup; context: modalData"></ng-container>
}
